import React from 'react';

import { get, IntlManager, isEmptyCollection, useApplicationState } from '@atlas/core';

import { BASE_PATH, currencyIcons } from 'common/constants';
import useTranslate from 'common/I18n/Interpreter';

const placeCup = place => {
  const cups = {
    1: `${BASE_PATH}/static/assets/svg/first_cup.svg`,
    2: `${BASE_PATH}/static/assets/svg/second_cup.svg`,
    3: `${BASE_PATH}/static/assets/svg/third_cup.svg`,
  };
  return cups[place];
};

const CompetitionTable = ({ data }) => {
  const t = useTranslate();

  const applicationState = useApplicationState();
  const accountId = get(applicationState, 'account.id');
  if (isEmptyCollection(data)) {
    return null;
  }

  return (
    <table className="promotion-table">
      <thead className="promotion-table__wrapper">
        <tr className="promotion-table__header">
          <th className="promotion-table__th">{t('place')}</th>
          <th className="promotion-table__th">{t('account_id')}</th>
          <th className="promotion-table__th">{t('prize')}</th>
        </tr>
      </thead>
      <tbody className="promotion-table__wrapper">
        {data.map(({ clientId, reward }, index) => (
          <tr className="promotion-table__content" key={`${index}${clientId}`}>
            <td className="promotion-table__td">
              <span className="promotion-table__place">{index + 1}</span>
              {index <= 2 && <img alt={index + 1} src={placeCup(index + 1)} />}
            </td>
            <td className="promotion-table__td">
              <div className="promotion-table__user">
                {clientId === accountId ? t('me') : clientId}
              </div>
            </td>
            <td className="promotion-table__td">
              {reward ? (
                <>
                  {/* TODO: remove hardcode here */}
                  {reward.financialReward && `${IntlManager.formatMoney(reward.financialReward)}`}
                  {reward.financialReward && reward.otherReward && ' + '}
                  {reward.otherReward}
                </>
              ) : (
                '--'
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CompetitionTable;
